module.exports = __webpack_public_path__ + "static/media/button_arrow_left.0cc81eb3.svg";